function hideHubspotForm(){$(".resellers-form-page .main_block").hide(),$(".resellers-form-page .success_block").show()}